import * as API from '../api'
export const FETCH_REFERENCE = 'FETCH_REFERENCE'
export const FETCHING_REFERENCE = 'FETCHING_REFERENCE'
export const FETCH_REFERENCE_ERROR = 'FETCH_REFERENCE_ERROR'
export const FETCH_REFERENCES = 'FETCH_REFERENCES'
export const FETCHING_REFERENCES = 'FETCHING_REFERENCES'
export const FETCH_REFERENCES_ERROR = 'FETCH_REFERENCES_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_REFERENCE = 'CHANGE_REFERENCE'
export const DELETE_REFERENCE = 'DELETE_REFERENCE'
export const ADD_REFERENCE = 'ADD_REFERENCE'
export const EDIT_REFERENCE = 'EDIT_REFERENCE'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_REFERENCE = 'NEW_FORM_REFERENCE'
export const REFERENCE_FORM_ERROR = 'REFERENCE_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeReference = reference => {
  return dispatch => {
    dispatch({ type: CHANGE_REFERENCE, reference })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const handleReferenceError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: REFERENCE_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormReference = reference => {
  return dispatch => {
    dispatch({ type: NEW_FORM_REFERENCE })
  }
}

export const setReferenceFormTouched = reference => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreReference = id => {
  return dispatch => {
    dispatch({ type: FETCHING_REFERENCES })
    return API.references
      .restoreReference(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_REFERENCE, reference: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_REFERENCES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleReferenceError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchReferences = options => {
  return dispatch => {
    dispatch({ type: FETCHING_REFERENCES })
    return API.references
      .getReferences(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_REFERENCES,
          references: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_REFERENCES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const deleteReference = id => {
  return dispatch => {
    dispatch({ type: FETCHING_REFERENCES })
    return API.references
      .deleteReference(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_REFERENCE, reference: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_REFERENCES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addReference = reference => {
  return dispatch => {
    dispatch({ type: FETCHING_REFERENCES })
    dispatch({ type: FETCHING_REFERENCE })
    return API.references
      .addReference(reference)
      .then(({ data }) => {
        dispatch({ type: ADD_REFERENCE, reference: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleReferenceError(response, dispatch)
        dispatch({
          type: FETCH_REFERENCES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editReference = reference => {
  return dispatch => {
    dispatch({ type: FETCHING_REFERENCES })
    dispatch({ type: FETCHING_REFERENCE })
    return API.references
      .editReference(reference)
      .then(({ data }) => {
        dispatch({ type: EDIT_REFERENCE, reference: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_REFERENCES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleReferenceError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchReference = id => {
  return dispatch => {
    dispatch({ type: FETCHING_REFERENCE, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.references
      .getReference(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_REFERENCE, reference: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_REFERENCE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/references.js